// eslint-disable-next-line import/prefer-default-export
export const ACCOUNT_TYPE = {
  CREDENTIAL: 'credential',
  CREDENTIALLESS: 'credentialless',
};
